<script>
</script>

<svg width="14" height="15" viewBox="0 0 14 15" fill="none">
  <path
    d="M13 8.83333V12.1667C13 12.5203 12.8595 12.8594 12.6095 13.1095C12.3594 13.3595 12.0203 13.5 11.6667 13.5H2.33333C1.97971 13.5 1.64057 13.3595 1.39052 13.1095C1.14048 12.8594 1 12.5203 1 12.1667V2.83333C1 2.47971 1.14048 2.14057 1.39052 1.89052C1.64057 1.64048 1.97971 1.5 2.33333 1.5H5.66667M8 6.5L13 1.5L8 6.5ZM9.66667 1.5H13V4.83333L9.66667 1.5Z"
    class={$$props.class || "stroke-[#B1B5C3]"}
    stroke-width="1.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
